// extracted by mini-css-extract-plugin
export default {"container":"wVvhx","starRating":"JiWBJ","star":"PHg45","containerLarge":"yyN31","screenreaderOnly":"seSWD"};